import { render, staticRenderFns } from "./recharge.vue?vue&type=template&id=45ca0a80&"
import script from "./recharge.vue?vue&type=script&lang=js&"
export * from "./recharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports